import semver from 'semver';
import React, { useContext, useState, useCallback, useEffect } from 'react';

var EventCallableRegsitry = /*#__PURE__*/function () {
  function EventCallableRegsitry() {
    this.registry = new Map();
  }

  var _proto = EventCallableRegsitry.prototype;

  _proto.addEventListener = function addEventListener(name, callback) {
    var callbacks = this.registry.get(name);

    if (callbacks) {
      callbacks.push(callback);
    } else {
      this.registry.set(name, [callback]);
    }
  };

  _proto.removeEventListener = function removeEventListener(name, callback) {
    var callbacks = this.registry.get(name);

    if (callbacks) {
      var indexOf = callbacks.indexOf(callback);

      if (indexOf > -1) {
        callbacks.splice(indexOf, 1);
      }
    }
  };

  _proto.dispatchEvent = function dispatchEvent(event) {
    // @ts-ignore
    if (window['debug']) {
      console.log('DEBUG::', 'Event:', event.name);
    }

    var callbacks = this.registry.get(event.name);

    for (var i in callbacks) {
      callbacks[i](event);
      if (!event.propagate) break;
    }
  };

  return EventCallableRegsitry;
}();

function dependencyValid(installedVersion, requiredVersion) {
  var versionDiff = semver.diff(installedVersion, requiredVersion);
  return (versionDiff === null || versionDiff === 'patch' || versionDiff === 'minor') && semver.gte(installedVersion, requiredVersion);
}

var PluginStore = /*#__PURE__*/function () {
  function PluginStore() {
    this._eventCallableRegistry = new EventCallableRegsitry();
    this.functionArray = new Map();
    this.pluginMap = new Map();
  }

  var _proto = PluginStore.prototype;

  _proto.install = function install(plugin) {
    var _this = this;

    var pluginNameAndVer = plugin.getPluginName();

    var _pluginNameAndVer$spl = pluginNameAndVer.split('@'),
        pluginName = _pluginNameAndVer$spl[0];

    var pluginDependencies = plugin.getDependencies() || [];
    var installationErrors = [];
    pluginDependencies.forEach(function (dep) {
      var _dep$split = dep.split('@'),
          depName = _dep$split[0],
          depVersion = _dep$split[1];

      var installedNameAndVer = _this.getInstalledPluginNameWithVersion(depName);

      var _ref = installedNameAndVer ? installedNameAndVer.split('@') : [null, ''],
          installedVersion = _ref[1];

      if (!installedNameAndVer) {
        installationErrors.push("Error installing " + pluginNameAndVer + ". Could not find dependency " + dep + ".");
      } else if (!dependencyValid(installedVersion, depVersion)) {
        installationErrors.push("Error installing " + pluginNameAndVer + ".\n" + installedNameAndVer + " doesn't satisfy the required dependency " + dep + ".");
      }
    });

    if (installationErrors.length === 0) {
      this.pluginMap.set(pluginName, plugin);
      plugin.init(this);
      plugin.activate();
    } else {
      installationErrors.forEach(function (err) {
        console.error(err);
      });
    }
  };

  _proto.getInstalledPluginNameWithVersion = function getInstalledPluginNameWithVersion(name) {
    var plugin = this.pluginMap.get(name);

    if (!plugin) {
      return null;
    }

    return plugin.getPluginName();
  };

  _proto.addFunction = function addFunction(key, fn) {
    this.functionArray.set(key, fn);
  };

  _proto.executeFunction = function executeFunction(key) {
    var fn = this.functionArray.get(key);

    if (fn) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return fn.apply(void 0, args);
    }

    console.error('No function added for the key ' + key + '.');
  };

  _proto.removeFunction = function removeFunction(key) {
    this.functionArray["delete"](key);
  };

  _proto.uninstall = function uninstall(key) {
    var plugin = this.pluginMap.get(key);

    if (plugin) {
      plugin.deactivate();
      this.pluginMap["delete"](key);
    }
  };

  _proto.addEventListener = function addEventListener(name, callback) {
    this._eventCallableRegistry.addEventListener(name, callback);
  };

  _proto.removeEventListener = function removeEventListener(name, callback) {
    this._eventCallableRegistry.removeEventListener(name, callback);
  };

  _proto.dispatchEvent = function dispatchEvent(event) {
    // @ts-ignore
    this._eventCallableRegistry.dispatchEvent(event);
  };

  return PluginStore;
}();

function createPluginStore() {
  return new PluginStore();
}

var PluginStoreContext = /*#__PURE__*/React.createContext( /*#__PURE__*/new PluginStore());

var PluginProvider = function PluginProvider(_ref) {
  var pluginStore = _ref.pluginStore,
      children = _ref.children;
  return React.createElement(PluginStoreContext.Provider, {
    value: pluginStore
  }, children);
};

function usePluginStore() {
  return useContext(PluginStoreContext);
} //   equivalence check will always be false, resulting in a re-render, even
//   when multiple calls to forceUpdate are batched.


function useForceUpdate() {
  var _useState = useState(Object.create(null)),
      dispatch = _useState[1]; // Turn dispatch(required_parameter) into dispatch().


  var memoizedDispatch = useCallback(function () {
    dispatch(Object.create(null));
  }, [dispatch]);
  return memoizedDispatch;
}

var Renderer = function Renderer(_ref) {
  var placement = _ref.placement;
  var pluginStore = usePluginStore();
  var forceUpdate = useForceUpdate();
  useEffect(function () {
    var eventListener = function eventListener(event) {
      if (event.position === placement) {
        forceUpdate();
      }
    };

    pluginStore.addEventListener('Renderer.componentUpdated', eventListener);
    return function () {
      pluginStore.removeEventListener('Renderer.componentUpdated', eventListener);
    };
  }, [pluginStore, placement, forceUpdate]);
  var components = pluginStore.executeFunction('Renderer.getComponentsInPosition', placement);
  return React.createElement(React.Fragment, null, components.map(function (compObject) {
    return React.createElement(compObject.component, {
      key: compObject.key
    });
  }));
};

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var Event = /*#__PURE__*/function () {
  function Event(name) {
    this.name = name; // this.target = target;
    // this.currentTarget = currentTarget;

    this._propagate = true;
    this._defaults = true;
  }

  var _proto = Event.prototype;

  _proto.stopPropagation = function stopPropagation() {
    this._propagate = false;
  };

  _proto.preventDefault = function preventDefault() {
    this._defaults = false;
  };

  _createClass(Event, [{
    key: "propagate",
    get: function get() {
      return this._propagate;
    }
  }, {
    key: "defaults",
    get: function get() {
      return this._defaults;
    }
  }]);

  return Event;
}();

var ComponentUpdatedEvent = /*#__PURE__*/function (_Event) {
  _inheritsLoose(ComponentUpdatedEvent, _Event);

  function ComponentUpdatedEvent(name, position) {
    var _this;

    _this = _Event.call(this, name) || this;
    _this.position = position;
    return _this;
  }

  return ComponentUpdatedEvent;
}(Event);

function randomString(length) {
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  text = possible.charAt(Math.floor(Math.random() * 52));

  for (var i = 0; i < length - 1; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

var RendererPlugin = /*#__PURE__*/function () {
  function RendererPlugin() {
    this.pluginStore = new PluginStore();
    this.componentMap = new Map();
  }

  var _proto = RendererPlugin.prototype;

  _proto.getPluginName = function getPluginName() {
    return 'Renderer@1.0.0';
  };

  _proto.getDependencies = function getDependencies() {
    return [];
  };

  _proto.init = function init(pluginStore) {
    this.pluginStore = pluginStore;
  };

  _proto.addToComponentMap = function addToComponentMap(position, component, key) {
    var array = this.componentMap.get(position);
    var componentKey = key ? key : randomString(8);

    if (!array) {
      array = [{
        component: component,
        key: componentKey
      }];
    } else {
      array.push({
        component: component,
        key: componentKey
      });
    }

    this.componentMap.set(position, array);
    this.pluginStore.dispatchEvent(new ComponentUpdatedEvent('Renderer.componentUpdated', position));
  };

  _proto.removeFromComponentMap = function removeFromComponentMap(position, component) {
    var array = this.componentMap.get(position);

    if (array) {
      array.splice(array.findIndex(function (item) {
        return item.component === component;
      }), 1);
    }

    this.pluginStore.dispatchEvent(new ComponentUpdatedEvent('Renderer.componentUpdated', position));
  };

  _proto.getRendererComponent = function getRendererComponent() {
    return Renderer;
  };

  _proto.getComponentsInPosition = function getComponentsInPosition(position) {
    var componentArray = this.componentMap.get(position);
    if (!componentArray) return [];
    return componentArray;
  };

  _proto.activate = function activate() {
    this.pluginStore.addFunction('Renderer.add', this.addToComponentMap.bind(this));
    this.pluginStore.addFunction('Renderer.getComponentsInPosition', this.getComponentsInPosition.bind(this));
    this.pluginStore.addFunction('Renderer.getRendererComponent', this.getRendererComponent.bind(this));
    this.pluginStore.addFunction('Renderer.remove', this.removeFromComponentMap.bind(this));
  };

  _proto.deactivate = function deactivate() {
    this.pluginStore.removeFunction('Renderer.add');
    this.pluginStore.removeFunction('Renderer.getComponentsInPosition');
    this.pluginStore.removeFunction('Renderer.getRendererComponent');
    this.pluginStore.removeFunction('Renderer.remove');
  };

  return RendererPlugin;
}();

export { Event, PluginProvider, PluginStore, RendererPlugin, createPluginStore, usePluginStore };